import { http } from './http.service';
import {
  HoldCode,
  ProductDetail,
  ProductDetailDownloadSDSReq,
  ProductDetailQueryCoaReq,
  ProductDetailQueryCoaRes,
  RecommendProduct,
} from '@/types/product-detail';

class ProductDetailService {
  getDetail = async (catalogNumber) => {
    const response = await http.post<ProductDetail>('/api/search/catalog/detail', {
      catalogNumber,
    });
    return response;
  };

  getSDSDocumentLink = async (req: ProductDetailDownloadSDSReq) => {
    const response = await http.get(`/api/document/search/sds?childSkus=${req.childSkus}&language=${req.language}`);
    return response;
  };

  getCoaInfo = async (req: ProductDetailQueryCoaReq) => {
    const response = await http.post<ProductDetailQueryCoaRes>(
      `/service/coa?pageNo=${req.pageNo}&pageSize=${req.pageSize}`,
      {
        catalogNumber: req.sku,
        lotNumber: req.lotNumber,
        rootSku: req.rootSku,
        brandName: req.brandName,
      }
    );
    return response;
  };

  getSpecificationSheet = async (catalogNumber: string, rootCatalogNumber: string) => {
    const response = await http.get<string>(
      `/api/document/search/specification?childSku=${catalogNumber}&rootSku=${rootCatalogNumber}`
    );
    return response;
  };

  getHoldCode = async (catalogNumber: string) => {
    const response = await http.post<HoldCode[]>('/api/search/catalog/holdcode', {
      catalogNumber,
    });
    return response;
  };

  getRecommendedProducts = async (catalogNumber: string) => {
    return await http.get<RecommendProduct[]>(`/api/recommended/search?rootSku=${catalogNumber}`);
  };
}

export const productDetailService = new ProductDetailService();
